import stool from './img/stool.png'
import teaTable from './img/Tea-table.png'
import sofaLight from './img/Sofa-white.png'
import sofaDark from './img/Sofa-black.png'
import tableLamp from './img/table-lamp.png'
import chair from './img/chair.png'
import bedsideTable from './img/bedside-table.png'
import lightChair from './img/light-chair.png'

export const storeData = [
    {
        id: 1,
        category: 'Home decor',
        title: 'Stool',
        image: stool,
        price: 200
    },
    {
        id: 2,
        category: 'Home decor',
        title: 'Tea table',
        image: teaTable,
        price: 150
    },
    {
        id: 3,
        category: 'Home decor',
        title: 'Sofa-Light',
        image: sofaLight,
        price: 300
    },
    {
        id: 4,
        category: 'Home decor',
        title: 'Sofa-Dark',
        image: sofaDark,
        price: 300
    },
    {
        id: 5,
        category: 'Home decor',
        title: 'Table Lamp',
        image: tableLamp,
        price: 50
    },
    {
        id: 6,
        category: 'Home decor',
        title: 'Chair',
        image: chair,
        price: 200
    },
    {
        id: 7,
        category: 'Home decor',
        title: 'Bedside Table',
        image: bedsideTable,
        price: 100
    },
    {
        id: 8,
        category: 'Home decor',
        title: 'Light Chair',
        image: lightChair,
        price: 80
    },
]